export default __webpack_public_path__ + "images/2Z.00ef13c.png";